import { render, staticRenderFns } from "./ContactEditTab.vue?vue&type=template&id=355275d2&"
import script from "./ContactEditTab.vue?vue&type=script&lang=js&"
export * from "./ContactEditTab.vue?vue&type=script&lang=js&"
import style0 from "./ContactEditTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports